
export default function Vision() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-[900px] mx-auto px-6 lg:px-12 text-center">
        <h2 className="text-4xl lg:text-5xl font-bold text-black mb-10 leading-tight">
          VISION
        </h2>
        
        <div className="space-y-3 text-gray-700 leading-relaxed text-lg">
          <p>
            We believe in the power of experiences crafted by creativity
          </p>
          <p>
            Experience is a "seamless" value whose form is shaped by imagination
          </p>
          <p>
            Great experiences can amplify
          </p>
          <p>
            Joy, not boredom<br />
            Connection, not isolation<br />
            Wonder, not indifference
          </p>
          <p>
            in everyday life
          </p>
          <p className="font-semibold pt-2">
            We design experiences that spark wonder and joy in the world
          </p>
        </div>
      </div>
    </section>
  );
}
